/**
 * 路由守卫
 */
import router from "./router";
import store from "./store";
import {
  Message
} from "element-ui";
import NProgress from "nprogress";
import {
  getToken
} from "./utils/auth";
import {
  syncBaiduConsult
} from "./utils/baiduConsult";

NProgress.configure({
  showSpinner: false
});
// const whiteList = ["/home/login", "/home/ProductItem", "/home/wechatAuth","/home"];
const whiteList = ["/login", "/wechatAuth","/home"];

router.beforeEach((to, from, next) => {
  NProgress.start();
  console.log(getToken(), 'getToken()')
  if (getToken()) {
    if (to.path === "/login") {
      next(
        // {
        // path: "/home"
        // }
      );
      NProgress.done();
    } else if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      // 需授权路由处理逻辑
      next();
    }
  } else {
    // 没有token
    console.log(9993)
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});

router.afterEach((to) => {
  NProgress.done();
  syncBaiduConsult(to.path);
});

syncBaiduConsult(router.currentRoute.path);



// WEBPACK FOOTER //
// ./src/permission.js